<template>
	<div id="divpessoa">
		<div class="card mb-3" style="border-radius: 13px">
			<div class="card-body p-2">
				<div class="row">
					<div
						class="col-xs-12 mb-4 d-flex justify-content-center"
						:class="{
							'col-sm-2': props.feedback_page,
							'col-sm-4': !props.feedback_page,
						}">
						<img
							v-if="props.student_image"
							id="photo-preview"
							:src="props.student_image"
							class="rounded"
							style="width: 150px; height: 150px" />

                        <browser_webcam_preview
                            v-else-if="props.browser_webcam_streaming_enabled"
                            :height="150"
                            :width="150"
                        />
                        <webrtc_video_player
                            v-else
                            :height="150"
                            :width="150"
                            :source_url="props.streaming_source"
                            :streaming_auth_credential="props.streaming_auth_credential"
                        />
					</div>

					<div class="col-xs-12 col-sm-8">
						<div class="d-inline">
							<span
								class="text-gray-900 text-hover-primary fs-4 fw-bolder me-1">
								{{ props.nomeAluno }}
							</span>
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="24px"
								height="24px"
								viewBox="0 0 24 24">
								<path
									d="M10.0813 3.7242C10.8849 2.16438 13.1151 2.16438 13.9187 3.7242V3.7242C14.4016 4.66147 15.4909 5.1127 16.4951 4.79139V4.79139C18.1663 4.25668 19.7433 5.83365 19.2086 7.50485V7.50485C18.8873 8.50905 19.3385 9.59842 20.2758 10.0813V10.0813C21.8356 10.8849 21.8356 13.1151 20.2758 13.9187V13.9187C19.3385 14.4016 18.8873 15.491 19.2086 16.4951V16.4951C19.7433 18.1663 18.1663 19.7433 16.4951 19.2086V19.2086C15.491 18.8873 14.4016 19.3385 13.9187 20.2758V20.2758C13.1151 21.8356 10.8849 21.8356 10.0813 20.2758V20.2758C9.59842 19.3385 8.50905 18.8873 7.50485 19.2086V19.2086C5.83365 19.7433 4.25668 18.1663 4.79139 16.4951V16.4951C5.1127 15.491 4.66147 14.4016 3.7242 13.9187V13.9187C2.16438 13.1151 2.16438 10.8849 3.7242 10.0813V10.0813C4.66147 9.59842 5.1127 8.50905 4.79139 7.50485V7.50485C4.25668 5.83365 5.83365 4.25668 7.50485 4.79139V4.79139C8.50905 5.1127 9.59842 4.66147 10.0813 3.7242V3.7242Z"
									fill="#00A3FF"></path>
								<path
									class="permanent"
									d="M14.8563 9.1903C15.0606 8.94984 15.3771 8.9385 15.6175 9.14289C15.858 9.34728 15.8229 9.66433 15.6185 9.9048L11.863 14.6558C11.6554 14.9001 11.2876 14.9258 11.048 14.7128L8.47656 12.4271C8.24068 12.2174 8.21944 11.8563 8.42911 11.6204C8.63877 11.3845 8.99996 11.3633 9.23583 11.5729L11.3706 13.4705L14.8563 9.1903Z"
									fill="white"></path>
							</svg>
							<span
								class="d-flex align-items-center text-gray-400 text-hover-primary mb-2">
								<i class="me-1 fa fa-user me-2"></i>
								CPF: {{ props.cpfAluno }}
							</span>
							<span
								class="d-flex align-items-center text-gray-400 text-hover-primary mb-2">
								<i class="me-1 fa fa-desktop me-2"></i>
								Equipamento: {{ props.computerUID }}
							</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
	import { usePage } from '@inertiajs/vue3';
    import Webrtc_video_player from '../Widgets/webrtc_video_player.vue';
    import browser_webcam_preview from './browser_webcam_preview.vue';

	const props = defineProps({
		nomeAluno: { type: String, required: true },
		cpfAluno: { type: String, required: true },
		computerUID: { type: String, required: true },
		totalQuestions: { type: Number, required: true },
		totalAnswered: { type: Number, required: true },
		deadline: { type: String, required: true },
		feedback_page: { type: Boolean, required: false },
		student_image: { type: String, required: false },
        streaming_source: { type: String, required: false, default: '' },
        streaming_auth_credential: { type: String, required: false, default: '' },
        browser_webcam_streaming_enabled: { type: Boolean, required: false, default: false },
    });

	const logout_exam_url: string = usePage().props
		?.logout_exam_url_global as string;
</script>

<style scoped>
	.btn-logout {
		border-color: #ff662a;
		color: #ff662a;
	}
	.btn-logout:hover {
		border-color: black;
		color: black;
	}
</style>
